import { render, staticRenderFns } from "./phcontactus.vue?vue&type=template&id=a4a9ad14"
import script from "./phcontactus.vue?vue&type=script&lang=js"
export * from "./phcontactus.vue?vue&type=script&lang=js"
import style0 from "./phcontactus.vue?vue&type=style&index=0&id=a4a9ad14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports